// extracted by mini-css-extract-plugin
module.exports = {"link":"link_button-module--link--2plI5","link__white":"link_button-module--link__white--TLf5Q","link__black":"link_button-module--link__black--naMJ-"};